import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { ChartMetricSelector } from './ChartMetricSelector';
import { FaIcon } from '../FaIcon';
import { Switch } from '../buttons/Swtich';

class ChartControlsComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isAdjustMenuOpen: false,
        };
        this.handleMetric1Change = this.handleMetric1Change.bind(this);
        this.handleMetric2Change = this.handleMetric2Change.bind(this);
        this.handleTimePeriodChange = this.handleTimePeriodChange.bind(this);
        this.adjustMenuRef = React.createRef();
        this.handleClickOutside = this.handleClickOutside.bind(this);
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside(event) {
        if (this.adjustMenuRef.current && !this.adjustMenuRef.current.contains(event.target)) {
            this.setState({ isAdjustMenuOpen: false });
        }
    }

    handleMetric1Change(metricId) {
        const { onMetricsChange, metrics } = this.props;
        if (onMetricsChange) {
            onMetricsChange([metricId, metrics ? metrics[1] : null]);
        }
    }

    handleMetric2Change(metricId) {
        const { onMetricsChange, metrics } = this.props;
        if (onMetricsChange) {
            onMetricsChange([metrics ? metrics[0] : null, metricId]);
        }
    }

    handleTimePeriodChange(period) {
        const { onTimePeriodChange } = this.props;
        if (onTimePeriodChange) {
            onTimePeriodChange(period);
        }
        this.setState({ isAdjustMenuOpen: false });
    }

    getPeriodLabel(period) {
        const { t } = this.props;
        const labels = {
            'DAILY': t('data_explorer.daily', 'Diario'),
            'WEEKLY': t('data_explorer.weekly', 'Semanal'),
            'MONTHLY': t('data_explorer.monthly', 'Mensual'),
        };
        return labels[period] || period;
    }

    render() {
        const { t, metrics, timePeriod, availableTimePeriods, defaultTimePeriod, fieldsData, sourceType, availableMetrics, showTooltip, onShowTooltipChange } = this.props;

        return (
            <div className="chart-controls">
                {/* Contenedor para los selectores de métricas - alineados a la derecha */}
                <div className="chart-controls__metrics-container">
                    {/* Selector de métrica 1 */}
                    <ChartMetricSelector
                        selectedMetric={metrics && metrics[0] ? metrics[0] : null}
                        selectedMetricForExclusion={metrics && metrics[1] ? metrics[1] : null}
                        onSelect={this.handleMetric1Change}
                        fieldsData={fieldsData}
                        sourceType={sourceType}
                        metricIndex={0}
                        availableMetrics={availableMetrics}
                    />

                    {/* Selector de métrica 2 */}
                    <ChartMetricSelector
                        selectedMetric={metrics && metrics[1] ? metrics[1] : null}
                        selectedMetricForExclusion={metrics && metrics[0] ? metrics[0] : null}
                        onSelect={this.handleMetric2Change}
                        fieldsData={fieldsData}
                        sourceType={sourceType}
                        metricIndex={1}
                        availableMetrics={availableMetrics}
                    />
                </div>

                {/* Botones de ajuste */}
                <div className="chart-controls__action-buttons" ref={this.adjustMenuRef}>
                    <button
                        type="button"
                        className="btn chart-controls__action-button no-margin-bottom"
                        title={t('data_explorer.adjust', 'Ajustar')}
                        onClick={() => this.setState({ isAdjustMenuOpen: !this.state.isAdjustMenuOpen })}
                    >
                        <FaIcon iconName="cog" />
                    </button>
                    
                    {this.state.isAdjustMenuOpen && (
                        <div className="chart-controls__adjust-menu">
                            {/* Toggle para mostrar/ocultar tooltip */}
                            <div
                                className="chart-controls__adjust-menu-switch"
                                onClick={(e) => e.stopPropagation()}
                            >
                                <Switch
                                    name="showTooltip"
                                    checked={showTooltip !== false}
                                    onChange={(e) => onShowTooltipChange && onShowTooltipChange(e.target.checked)}
                                    style={{ margin: 0 }}
                                />
                                <label
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        onShowTooltipChange && onShowTooltipChange(showTooltip === false);
                                    }}
                                >
                                    {t('data_explorer.show_labels', 'Mostrar detalle')}
                                </label>
                            </div>
                            {availableTimePeriods && availableTimePeriods.length > 0 && (
                                <>
                                    <div className="chart-controls__adjust-menu-title">
                                        {t('data_explorer.time_period', 'Período de tiempo')}
                                    </div>
                                    {availableTimePeriods.map(period => {
                                        const currentPeriod = timePeriod || defaultTimePeriod;
                                        return (
                                            <div
                                                key={period}
                                                onClick={() => this.handleTimePeriodChange(period)}
                                                className={`chart-controls__adjust-menu-option ${currentPeriod === period ? '-selected' : ''}`}
                                            >
                                                {this.getPeriodLabel(period)}
                                            </div>
                                        );
                                    })}
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}

export const ChartControls = withTranslation()(ChartControlsComponent);

